<nav class="navbar navbar-expand-lg" style="background-color:#101820;">
    <div class="container-fluid">
      <a class="navbar-brand" href="https://www.conetools.com">
        <img [src]="AssetbasePath + '/Content/MainImages/ConeDrive_Inv_T.png'" 
     alt="Logo" 
     class="d-inline-block align-text-top navbar-dark">

      </a>

      <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <a class="nav-link" href="https://www.conedrive.com" target="_blank" style="color:white">Cone Drive</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="https://www.conetools.com" target="_blank" style="color:white">Cone Tools</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="http://www.conedrive.com/contact-2/" target="_blank" style="color:white">Contact</a>
                </li>
            </ul>
        </div>  
    </div>
    
  </nav>